import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

/**
 * Route dispatcher — Orinest Integrated Hospitality MIS
 *
 *   /admin            → AdminApp     (platform super-admin)
 *   /?tenant={slug}   → TenantApp    (business tenant portal — same endpoint, slug-based)
 *   /tenant           → TenantApp    (legacy direct path, still supported)
 *   /                 → PublicApp    (public-facing website)
 *
 * In development:   http://localhost:3001/?tenant=bim
 *                   http://localhost:3001/?tenant=casagrandehotel
 * In production:    https://yourdomain.com/?tenant=bim
 */
const path   = window.location.pathname;
const params = new URLSearchParams(window.location.search);
const tenant = params.get('tenant');   // e.g. "bim", "casagrandehotel"

const root = ReactDOM.createRoot(document.getElementById('root'));

if (path.startsWith('/admin')) {
  import('./apps/AdminApp').then(({ default: AdminApp }) =>
    root.render(<React.StrictMode><AdminApp /></React.StrictMode>));
} else if (tenant || path.startsWith('/tenant')) {
  // Pass the tenantSlug hint so TenantApp can show context-aware login
  import('./apps/TenantApp').then(({ default: TenantApp }) =>
    root.render(<React.StrictMode><TenantApp tenantSlug={tenant || null} /></React.StrictMode>));
} else {
  import('./apps/PublicApp').then(({ default: PublicApp }) =>
    root.render(<React.StrictMode><PublicApp /></React.StrictMode>));
}
